module.exports = __webpack_public_path__ + "static/media/mens-health-wa.ff359a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/mens-health-wa.png
// module id = 65
// module chunks = 0